import Intercom from '@intercom/messenger-js-sdk';

export default function FinAgent() {
  Intercom({
    app_id: process.env.VITE_INTERCOM_APP_ID || 'pxa6fz3p',
    // Lift the launcher above the TrustsAdvisor certificate badge (60px tall at bottom:20px)
    vertical_padding: 95,
  });

  return <div></div>;
}